/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { TodoStatus } from '@gh/builder-shared-data';
import { LAYOUT_TODO_INBOX_DONE, LAYOUT_TODO_PASSED } from '@gh/core-ui-grid';

import { eq } from 'lodash';

export const SHOW_TYPE_INBOX = 'INBOX';
export const SHOW_TYPE_DONE = 'DONE';
export const SHOW_TYPE_PASSED = 'PASSED';

export const isInboxDoneShowType =
  (type: string): boolean => [SHOW_TYPE_INBOX, SHOW_TYPE_DONE].includes(type);

export const chooseDefinitionByType =
  (type: string): string => isInboxDoneShowType(type) ? LAYOUT_TODO_INBOX_DONE : LAYOUT_TODO_PASSED;

export const justInboxStatus = ({ status }: any) => eq(status, TodoStatus.INBOX);
export const justDoneStatus = ({ status }: any) => eq(status, TodoStatus.DONE);
export const notInboxStatus = ({ status }: any) => !eq(status, TodoStatus.INBOX);
export const notDoneStatus = ({ status }: any) => !eq(status, TodoStatus.DONE);
